<template>
  <section class="mb-5 mt-5">
    <vue-headful
      v-if="!loading"
      :title="`${this.arms[0].name} | Thong Firearms ปืนธง`"
      :description="`${this.arms[0].name} ${this.arms[0].detail}`"
      :keywords="
        `${this.arms[0].name}, Thong Firearms, ปืนธง, ${
          categorys[this.arms[0].category]
        }, ${brand[this.arms[0].brand]}`
      "
      :image="`http://thongarms.com/src/assets/product/${this.arms[0].img}`"
      :lang="`th`"
    />
    <div class="container">
      <div class="text-center w-100">
        <div class="spinner-grow text-danger" role="status" v-if="loading">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <div v-for="arm in arms" :key="arm.id">
        <b-overlay
          :show="arm.show == 'FALSE' || arm.show == false"
          class="d-inline-block"
          bg-color="white"
          opacity="0.9"
          blur="10px"
        >
          <div class="row" v-if="arm !== null">
            <div class="col-12 text-left mb-5 mb-3">
              <router-link
                class="text-dark"
                v-bind:to="'/category/' + arm.category"
                >หมวด {{ categorys[arm.category] }}</router-link
              >&nbsp;>
              <router-link class="text-dark" v-bind:to="'/brand/' + arm.brand"
                >ยี่ห้อ {{ brand[arm.brand] }}</router-link
              >&nbsp;>
              <span class="color-70">รายละเอียด {{ arm.name }}</span>
            </div>
          </div>

          <div class="w-100 text-center" v-if="arm == null">
            <div class="spinner-grow text-danger" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div class="row wow fadeIn" v-if="arm !== null">
            <div
              class="col-lg-5 max-width d-flex justify-content-center align-items-start min-height"
            >
              <div>
                <span v-if="arm.img">
                  <v-zoom
                    :img="`../src/assets/product/${arm.img}`"
                    width="500"
                    style="padding: 30px"
                  ></v-zoom>
                </span>
                <span v-else-if="arm.img == 'undefined'">
                  <img src="../assets/logo.png" alt />
                </span>
                <span v-else>
                  <img src="../assets/logo.png" alt />
                </span>
                <p class="font-14 mt-5 color-70">
                  “โปรดเช็คสถานะสินค้าและราคากับทางร้านฯ อีกครั้ง
                  เนื่องจากเป็นสินค้านำเข้า”
                </p>
              </div>
            </div>
            <div class="col-lg-7">
              <h4 class="product-name">{{ arm.name }}</h4>
              <h2 v-if="arm.inStock == 0" class="text-danger">OUT OF STOCK</h2>
              <p>
                หมวดหมู่ :
                <router-link
                  class="text-dark"
                  v-bind:to="'/category/' + arm.category"
                  >{{ categorys[arm.category] }}</router-link
                >
              </p>
              <p>
                ประเภท :
                <router-link class="text-dark" v-bind:to="'/type/' + arm.type">
                  {{ type[arm.type] }}
                </router-link>
              </p>
              <p>
                ยี่ห้อ :
                <router-link
                  class="text-dark"
                  v-bind:to="'/brand/' + arm.brand"
                  >{{ brand[arm.brand] }}</router-link
                >
              </p>
              <p v-if="arm.detail">
                รายละเอียด :
                <span class="color-70 pre-wrap">{{ arm.detail }}</span>
              </p>
              <b-table-simple hover small caption-top responsive>
                <caption>
                  ข้อมูลทางเทคนิค
                </caption>
                <b-tbody>
                  <b-tr>
                    <b-th class="w-25">ความยาวทั้งหมด<sup>(นิ้ว)</sup></b-th>
                    <b-td class="text-capitalize">{{
                      arm.length ? arm.length : "-"
                    }}</b-td>
                    <b-th class="">ขนาดกระสุน</b-th>
                    <b-td class="text-capitalize w-75">{{
                      arm.caliber
                        ? arm.caliber.toString().replace("0", "")
                        : "-"
                    }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="w-25">ความยาวลำกล้อง<sup>(นิ้ว)</sup></b-th>
                    <b-td class="text-capitalize">{{
                      arm.barrellength ? arm.barrellength : "-"
                    }}</b-td>
                    <b-th class="w-25">บรรจุ<sup>(นัด)</sup></b-th>
                    <b-td class="text-capitalize w-75">{{
                      arm.capacity ? arm.capacity : "-"
                    }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="w-25">น้ำหนัก<sup>(กก.)</sup></b-th>
                    <b-td class="text-capitalize">{{
                      arm.weight ? arm.weight : "-"
                    }}</b-td>
                    <b-th class="w-25">ศูนย์</b-th>
                    <b-td class="text-capitalize w-75">{{
                      arm.sights ? arm.sights : "-"
                    }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="w-25">ระบบความปลอดภัย</b-th>
                    <b-td class="text-capitalize">{{
                      arm.safety ? arm.safety : "-"
                    }}</b-td>
                    <b-th class="">ลำกล้อง</b-th>
                    <b-td class="text-capitalize w-75">{{
                      arm.barrel ? arm.barrel : "-"
                    }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="w-25">ระบบไก</b-th>
                    <b-td class="text-capitalize">{{
                      arm.trigger ? arm.trigger : "-"
                    }}</b-td>
                    <b-th class="">{{
                      arm.category == 1 ? "ทรงปืน" : "ระบบป้อนกระสุน"
                    }}</b-th>
                    <b-td class="text-capitalize w-75">{{
                      arm.size || arm.supplytype
                        ? arm.category == 1
                          ? arm.size
                          : arm.supplytype
                        : "-"
                    }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="w-25">{{
                      arm.category == 1 ? "โครงปืน" : "ร่องแก้มพานท้าย"
                    }}</b-th>
                    <b-td class="text-capitalize w-25">{{
                      arm.frame || arm.cheekpiece
                        ? arm.category == 1
                          ? arm.frame
                          : arm.cheekpiece
                        : "-"
                    }}</b-td>
                    <b-th class="">{{
                      arm.category == 1 ? "ด้าม" : "ตัวช่วยลดแรงสะบัด"
                    }}</b-th>
                    <b-td class="text-capitalize w-75">{{
                      arm.grips || arm.compensator
                        ? arm.category == 1
                          ? arm.grips
                          : arm.compensator
                        : "-"
                    }}</b-td>
                  </b-tr>
                  <b-tr v-if="arm.category == 2">
                    <b-th class="w-25">ความยาวพานท้าย<sup>(นิ้ว)</sup></b-th>
                    <b-td class="text-capitalize">{{
                      arm.lop ? arm.lop : "-"
                    }}</b-td>
                    <b-th class="">เกลียวปลาย</b-th>
                    <b-td class="text-capitalize w-75">{{
                      arm.thread ? arm.thread : "-"
                    }}</b-td>
                  </b-tr>
                  <b-tr v-if="arm.category == 2">
                    <b-th class="w-25">วัสดุพานท้าย</b-th>
                    <b-td class="text-capitalize">{{
                      arm.stock ? arm.stock : "-"
                    }}</b-td>
                    <b-th class="">ผิวพานท้าย</b-th>
                    <b-td class="text-capitalize w-75">{{
                      arm.stocksurface ? arm.stocksurface : "-"
                    }}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
          <template v-slot:overlay>
            <div class="text-center">
              <b-icon
                icon="x-circle"
                font-scale="4"
                animation="throb"
                variant="danger"
              ></b-icon>
              <p class="text-danger font-size-25">SOLD OUT!</p>
            </div>
          </template>
        </b-overlay>
      </div>
    </div>
  </section>
</template>

<script>
import { db } from "../config_db";
import vZoom from "vue-zoom";

export default {
  components: {
    vZoom
  },
  firebase() {
    return {
      arms: {
        source: db
          .ref("product")
          .orderByChild("id")
          .equalTo(Number.parseInt(this.$route.params.id)),
        readyCallback: () => {
          // this.loadTitle();
          this.loading = false;
        }
      }
    };
  },
  data() {
    return {
      //id: this.$route.params.id,
      loading: true,
      // arm: [],
      type: [
        "",
        "กึ่งอัตโนมัติ",
        "ลูกโม่",
        "ลูกซอง",
        "ลูกเลื่อน",
        "คานเหวี่ยง",
        "ไรเฟิล"
      ],
      categorys: ["", "ปืนสั้น", "ปืนยาว"],
      brand: [
        "",
        "BENELLI",
        "BERETTA",
        "BROWNING",
        "COLT",
        "CZ",
        "GLOCK",
        "HENRY",
        "REMINGTON",
        "SMITH&WESSON",
        "STANDARD MFG. (U.S.A.)",
        "TARAN TACTICAL INNOVATIONS JOHN WICK",
        "Zev Technologies",
        "BAIKAL",
        "CMMG",
        "TippMann",
        "DERYA",
        "STACCATO",
        "I.C.R.W.",
        "MOSSBERG",
        "MAXIM DEFENSE",
        "BUL Armory",
        "SIG SAUER",
        "PHOENIX TRINITY"
      ]
    };
  },
  methods: {
    // loadTitle() {
    //   document.title = this.arms[0].name + " | Thong Firearms ปืนธง";
    // }
  }
  // created() {
  //   this.$http
  //     .get("https://thongarms-2506.firebaseio.com/product/" + this.id + ".json")
  //     .then(function(data) {
  //       this.arm = data.body;
  //     });
  // }
};
</script>

<style scoped>
.table-sm td, .table-sm th{
  font-size: 95%;
}
.product-name {
  border-bottom: solid 2px #ccc;
  padding-bottom: 5px;
}
.min-height {
  min-height: 250px;
}
p {
  margin-bottom: 10px;
}
.carousel-indicators li {
  width: 23%;
  height: 70px;
  text-indent: 0;
  overflow: hidden;
  float: left;
  margin-left: 5px;
  margin-right: 5px;
}
.carousel-indicators {
  bottom: 0;
  margin: 0;
  position: relative;
}
.carousel-control-next,
.carousel-control-prev {
  z-index: 100;
}
.zoom:after {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/component/product.vue